
export class WareHouseProConfig {

    constructor() {
        this.Enable = false;
        this.WarehousePro = false;
        this.RemarkConfigurationForShipmentType = null;
        this.RemarkConfigurationForShipmentTime = null;
        this.CustomerCommunicationSettings = null;
        this.TwilioSMSConfiguration = null;
        this.EnableBulkItemConfiguration = null;
        this.AlertTemaplateSettings = null;
        this.RemarkConfigurationForDeliveryPoint = null;
    }

    Enable?: boolean;
    WarehousePro?: boolean;
    RemarkConfigurationForShipmentType?: any;
    RemarkConfigurationForShipmentTime?: any;
    CustomerCommunicationSettings?: any;
    TwilioSMSConfiguration?: any;
    AlertTemaplateSettings?: any;
    EnableBulkItemConfiguration?: any;
    RemarkConfigurationForDeliveryPoint?: any;

}

